import { OrganizationMigrationForm } from "../../components/OrganizationMigrationForm/OrganizationMigrationForm";

export const UserMigrationPage = () => {
    return <OrganizationMigrationForm />;
};

UserMigrationPage.displayName = "UserMigrationPage";
